/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ added: NonNullable<unknown>, removed: NonNullable<unknown>, swapped: NonNullable<unknown>, changed: NonNullable<unknown> }} Plan_Draft_Counts_LabelInputs */

const en_us2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} added, ${i?.removed} removed, ${i?.swapped} swapped, ${i?.changed} adjusted`)
};

const pt_br2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entram, ${i?.removed} saem, ${i?.swapped} trocas, ${i?.changed} ajustes`)
};

const es_419_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entran, ${i?.removed} salen, ${i?.swapped} cambios, ${i?.changed} ajustes`)
};

const pt_pt2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entram, ${i?.removed} saem, ${i?.swapped} trocas, ${i?.changed} ajustes`)
};

const fr_fr2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} ajoutés, ${i?.removed} retirés, ${i?.swapped} remplacés, ${i?.changed} ajustés`)
};

const de_de2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} hinzugefügt, ${i?.removed} entfernt, ${i?.swapped} getauscht, ${i?.changed} angepasst`)
};

const it_it2_plan_draft_counts_label = /** @type {(inputs: Plan_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} aggiunti, ${i?.removed} rimossi, ${i?.swapped} cambiati, ${i?.changed} ritoccati`)
};

/**
* | output |
* | --- |
* | "{added} added, {removed} removed, {swapped} swapped, {changed} adjusted" |
*
* @param {Plan_Draft_Counts_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_draft_counts_label = /** @type {((inputs: Plan_Draft_Counts_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Draft_Counts_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_draft_counts_label(inputs)
	if (locale === "es-419") return es_419_plan_draft_counts_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_draft_counts_label(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_draft_counts_label(inputs)
	if (locale === "de-DE") return de_de2_plan_draft_counts_label(inputs)
	if (locale === "it-IT") return it_it2_plan_draft_counts_label(inputs)
	return en_us2_plan_draft_counts_label(inputs)
});
export { plan_draft_counts_label as "plan.draft_counts_label" }